"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withDefault = void 0;

/**
 * Given a default state and reducer return a reducer that uses the default
 * state when the store is uninitialized.
 *
 * If no reducer is provided a reducer which just returns its input state unmodified
 * is used.
 *
 * @param defaultState The default state to use if the state of the store is undefined
 * @param reducer The reducer to invoke, if undefined the state will be returned as-is
 */
const withDefault = (defaultState, reducer = s => s) => (state = defaultState, action) => reducer(state, action);

exports.withDefault = withDefault;
//# sourceMappingURL=with-default.js.map
